export default __webpack_public_path__ + "static/media/RBAC.5cb7d90d.png";